module.exports = __webpack_public_path__ + "img/Airbnb-Sensory-Overload-Digital-Detox.fe23f7d2.jpg";